<template>
  <div class="fill">
    <div class="fill-head">
      <img src="../../static/images/fanhui (3).png" alt="" @click="goBlack" />
      <div>填写合作信息</div>
    </div>
    <div class="fill-explain">
      合作伙伴计划信息收集表,以下信息还请您依据自身情况如实填写
    </div>
    <input
      type="text"
      name=""
      class="public-box"
      placeholder="请输入公司名称"
      @change="getInputValue('company', $event)"
    />
    <div
      class="industry public-box"
      @click="openSelectModal('industry')"
      ref="industry"
    >
      {{ formData.industry ? formData.industry : "请选择所在行业" }}
      <div></div>
      <img src="../../static/images/zhankai .png" alt="" />
    </div>
    <div
      class="public-box industry"
      @click="openSelectModal('team')"
      ref="team"
    >
      {{ intentionTitle ? intentionTitle : "请选择合作意向" }}
      <div></div>
      <img src="../../static/images/zhankai .png" alt="" />
    </div>

    <input
      type="text"
      name=""
      class="public-box"
      placeholder="请输入联系人姓名"
      @change="getInputValue('name', $event)"
    />
    <input
      type="text"
      name=""
      class="public-box"
      placeholder="请输入联系人手机号"
      @change="getInputValue('phone', $event)"
    />
    <!-- <div class="verification">
      <input type="text" placeholder="请输入验证码" />
      <div class="obtain-btn">获取验证码</div>
    </div> -->
    <input
      type="text"
      name=""
      class="public-box"
      placeholder="请输入您的邮箱"
      @change="getInputValue('email', $event)"
    />
    <input
      type="text"
      name=""
      class="public-box"
      placeholder="请输入您的职位"
      @change="getInputValue('position', $event)"
    />

    <textarea
      type="text"
      class="remarks"
      placeholder="备注说明"
      @change="getInputValue('remarks', $event)"
    ></textarea>
    <div class="submit-btn" @click="confirmForm">确认提交</div>
    <div class="pop-box" v-if="showIndustry || showTeam">
      <div class="select-bg" @click="closeModal"></div>
      <div class="select-modal">
        <div class="title">请选择合作意向</div>
        <div
          class="item"
          v-show="showTeam"
          v-for="item in workList"
          :key="'work' + item.id"
          @click="getSelectItem('work', item)"
        >
          <p>{{ item.title }}</p>
          <div class="img-box">
            <img
              v-if="workId == item.id"
              src="../../static/images/duigou.png"
              alt=""
            />
            <img v-else src="../../static/images/weixuan.png" alt="" />
          </div>
        </div>
        <div
          class="item"
          v-show="showIndustry"
          v-for="item in industryList"
          :key="'industry' + item.id"
          @click="getSelectItem('industry', item)"
        >
          <p>{{ item.title }}</p>
          <div class="img-box">
            <img
              v-if="industryId == item.id"
              src="../../static/images/duigou.png"
              alt=""
            />
            <img v-else src="../../static/images/weixuan.png" alt="" />
          </div>
        </div>
        <div class="btn" @click="comfirm()">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showIndustry: false,
      showTeam: false,
      workList: [
        {
          id: 1,
          title: "经销合作伙伴",
        },
        {
          id: 2,
          title: "技术与实施伙伴",
        },
        {
          id: 3,
          title: "生态服务伙伴",
        },
      ],
      industryList: [],
      industryId: -1,
      workId: -1,
      formData: {},
      industryList: [],
      intentionTitle: "",
    };
  },
  created() {},
  mounted() {
    this.getIndustry();
    // this.teamColor();
    // this.industryColor();
  },
  methods: {
    goBlack() {
      this.$emit("setLastPage", "0");
    },
    getInputValue(type, e) {
      if (type != "") {
        this.$set(this.formData, type, e.target.value);
      }
    },
    confirmForm() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/partner",
        this.formData,
        (res) => {
          // console.log(res)
          if (res.code == 1) {
            alert("提交成功，我们会尽快与您取得联系。");
            this.$router.push("/m_cooperation");
          }
        },
        (err) => {
          alert(err.msg);
          // conosle.log(this.formData)
        }
      );
    },
    openSelectModal(type) {
      if (type == "industry") {
        this.showIndustry = true;
        // var t =document.body.clientHeight;
        // window.scroll({top:t,left:0,behavior:'smooth' });
      } else if (type == "team") {
        this.showTeam = true;
      }
    },
    comfirm() {
      if (this.showIndustry) {
        this.showIndustry = false;
      } else if (this.showTeam) {
        this.showTeam = false;
      }
    },
    getSelectItem(type, item) {
      if (type == "industry") {
        this.industryId = item.id;
        this.$set(this.formData, "industry", item.title);
        this.$refs.industry.style.color = "#333";
      } else if (type == "work") {
        this.workId = item.id;
        this.intentionTitle = item.title;
        this.$set(this.formData, "intention", item.id);
        this.$refs.team.style.color = "#333";
      }
    },
    closeModal(type) {
      this.showIndustry = false;
      this.showTeam = false;
    },
    getIndustry() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/industry",
        null,
        (res) => {
          // console.log(res);
          if (res.code == 1) {
            this.industryList = res.data;
          }
        }
      );
    },
  },
};
</script>
<style  lang="stylus" scoped>
.pop-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  overscroll-behavior: contain
  z-index: 2;
}

.select-bg {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  overflow hidden
}

.select-modal {
  width: 100%;
  height: auto;
  // overflow-y: scroll;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  border-radius: 20px 20px 0px 0px;

  .title {
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    font-weight: 500;
    color: #999999;
    text-align: center;
    border-bottom: 1px solid #EEEEEE;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 13px;
    width: 100%;
    height: 44px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #EEEEEE;
    margin-bottom: 1px;

    p {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }

    .img-box {
      width: 20px;
      height: 20px;
    }
  }

  .btn {
    text-align: center;
    line-height: 50px;
    width: 100%;
    height: 50px;
    background: #FFFFFF;
    font-size: 16px;
    font-weight: 500;
    color: #F63D3D;
    border-top: 5px solid #F5F5F5;
  }
}

.fill {
  position: relative;
  box-sizing: border-box;
  padding: 3.33% 3.33% 0;
}

.fill-head {
  // margin-top: 3.6%;
  display: flex;
}

.fill-head img {
  width: 5.33%;
  height: 5.33%;
}

.fill-head div {
  margin-left: 29.2%;
  font-size: 0.36rem;
  font-weight: bold;
}

.fill-explain {
  margin: 7.6% 0 0 0;
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #666666;
}

.public-box {
  width: 93.6%;
  padding-left: 4.13%;
  /* height: 11.73%; */
  background: #ffffff;
  border: 0.01rem solid #e1e6f0;
  border-radius: 0.08rem;
  line-height: 0.88rem;
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 2.66%;
}

.industry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.27rem 0 0.31rem;
  color: #999999;
}

.industry img {
  width: 2.56%;
  height: 30.4%;
}

.verification {
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
  width: 100%;
  height: 12.26%;
}

.verification input {
  border: 0.01rem solid #e1e6f0;
  width: 64.26%;
  height: 3.3em;
  padding-left: 4.13%;
}

.obtain-btn {
  margin-left: 2.66%;
  width: 26.66%;
  height: 11.73%;
  background: #ffc000;
  border-radius: 8px;
  text-align: center;
  line-height: 0.88rem;
  font-size: 0.24rem;
  color: #333333;
}

.remarks {
  width: 93.6%;
  /* height: 34.66%; */
  height: 8.6em;
  background: #ffffff;
  border: 0.01rem solid #e1e6f0;
  border-radius: 0.08rem;
  padding: 4.26% 0 0 4.13%;
}

textarea {
  resize: none;
}

.submit-btn {
  margin: 12.53% 0 3.2% 0;
  height: 11.73%;
  text-align: center;
  line-height: 0.88rem;
  font-size: 0.28rem;
  color: #333333;
  background: #ffc000;
  border-radius: 0.08rem;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/cooperationFill.vue